import React from 'react'
// import archivoListado from '../../assets/files/Concurso/Listado Provisional Concurso DEPGFMLUZ 2026.pdf'
import bannerListado from '../../assets/images/Carrusel/Listado-Definitivo-Concurso-DEPGFMLUZ-2026-Banner.png'
import { Link } from 'react-router-dom'

const ConcursoListadoDefinitivo = () => {
  const formLink = 'https://docs.google.com/forms/d/e/1FAIpQLSeBQ88nUPBz_-hs_CkmUkMZ80T5m7lfW6BuacEtX-tdlRkttQ/viewform?usp=preview'

  return (
    <div className='page-section instructivos listado-ganadores'>
        <section className='info-container listado-ganadores' id='index'>
          
          <div className='info-group start column mb-4'>
            <div className='banner-container'>
              <img className='page-banner' src={bannerListado} alt="Listado de Ganadores - Concurso DEPGFMLUZ 2026" />
            </div>

            <p className='spaced-lg'>La División de Estudios para Graduados de la Facultad de Medicina de la Universidad del Zulia informa que, concluido el período de reconsideraciones y atendidos los reclamos recibidos, se publica el listado definitivo de asignación de cupos. </p>

            <p className='spaced-lg'>En el concurso participaron aproximadamente 750 aspirantes: 450 venezolanos y 300 extranjeros. </p>

            <p className='spaced-lg'>Como resultado del proceso de revisión, se amplió la disponibilidad de cupos en algunas unidades docentes, con el propósito de preservar, en la medida de lo posible, las asignaciones previamente publicadas. </p>

            <p className='spaced-xl'>La distribución definitiva comprende 500 cupos, de los cuales el 80 % corresponde a aspirantes venezolanos y el 20 % a aspirantes extranjeros. </p>

            <Link
              className='btn-baremo btn btn-primary link-button my-0'
              to="/concurso/listado-definitivo-concurso"
            >
              Ver Listado Definitivo
            </Link>
            {/* <a 
              href={archivoListado}
              target='blank'
              // download={'CONCURSO DEPGFMLUZ 2025 LISTADO DEFINITIVO'} 
              className='btn-baremo rd btn btn-primary link-button px-4'
            >
              Ver Listado Definitivo
            </a> */}
          </div>
          
          <div className='info-group mt-3'>
            <h3 className='page-subtitle border-none'>Cronograma de Inscripción</h3>

            <p className='spaced-lg'>Solo para aspirantes seleccionados en el listado definitivo. </p>

            <p dangerouslySetInnerHTML={{__html: '<b>Fecha de inscripción</b> por terminal de documento de identidad cédula o pasaporte (en el caso de extranjeros): '}}></p>
            <ul className='lista-inscripcion fechas mb-4'>
              <li className='span-group'>
                <span className='span-lead'>Martes 03/10: </span>
                <span>1, 2, 3, 4</span>
              </li>
              <li className='span-group'>
                <span className='span-lead'>Miércoles 04/10: </span>
                <span>5, 6, 7</span>
              </li>
              <li className='span-group'>
                <span className='span-lead'>Jueves 05/10: </span>
                <span>8, 9, 0</span>
              </li>
            </ul>

            <div className='callout info mb-2'>
              <i class="bi bi-info-circle icon"></i>
              <p>Este formulario debe ser llenado de forma inmediata, para que administración se comunique con usted los días jueves 29/10, viernes 30/10, sábado 31/10 y lunes 02/11 para explicarle la forma de inscripción.</p>
            </div>
          </div>
          <div className='info-group list-column'>
            <h4 className='group-title sm mb-3'>Pasos para realizar la inscripción: </h4>
            <ol className='lista-inscripcion'>
              <li>Llenar el formulario de inscripción ubicado al final de esta página. </li>
              <li>Administración se comunicará con Usted vía WhatsApp, para indicarle los aranceles de inscripción. </li>
            </ol>
          </div>
          {/* <div className='info-group list-column'>
            <h4 className='group-title sm'>Entrega de la Carta de Asignación de Cupo: </h4>
            <div className='span-group'>
              <span className='span-lead'>Día: </span>
              <span>sábado 04 de enero de 2025.</span>
            </div>
          </div> */}

          

          <div className='info-group list-column mb-4'>
            <h4 className='group-title sm'>Inicio del Posgrado</h4>
            <p className=''>04 de enero de 2027</p>
          </div>

          <div className='info-group mb-0'>
            <a
              href={formLink}
              target='blank'
              className='btn-baremo btn btn-primary rd link-button px-4'
            >
              Formulario de Inscripción
            </a>
          </div>

          <div className='info-group list-column' hidden>
            <p className='name-p lead-name'>Dr. Freddy Pachano Arenas<br/>Director</p>
            <p className='name-p'>Dra. Jorymar Leal<br/>Secretaria Docente</p>
          </div>
        </section>
    </div>
  )
}

export { ConcursoListadoDefinitivo }